<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">add</i>
                        </div>
                        <h4 class="card-title ">Novo</h4>
                    </div>
                    <b-form @submit="onSubmit" novalidate="novalidate" autocomplete="off">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.name != '', 'has-danger' : validation.name != '' }">
                                        <label class="bmd-label-floating">Nome *</label>
                                        <input refs="name" type="text" class="form-control" v-model="form.name" />
                                        <label v-if="validation.name != ''" class="error">{{ validation.name }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled"
                                         v-bind:class="{'has-danger' : validation.lead_status_id != '' }">
                                        <label class="bmd-label-floating">Status *</label>
                                        <model-list-select
                                                class="form-control"
                                                :list="leads_status"
                                                option-value="id"
                                                option-text="status"
                                                v-model="form.lead_status_id"
                                        ></model-list-select>
                                        <label v-if="validation.lead_status_id != ''" class="error">{{ validation.lead_status_id }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.phone != '', 'has-danger' : validation.phone != '' }">
                                        <label class="bmd-label-floating">Telefone *</label>
                                        <the-mask refs="phone" type="text" class="form-control" v-model="form.phone" :mask="['(##) #####-####', '(##) #####-####']"></the-mask>
                                        <label v-if="validation.phone != ''" class="error">{{ validation.phone }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.email != '', 'has-danger' : validation.email != '' }">
                                        <label class="bmd-label-floating">E-mail</label>
                                        <input refs="email" type="mail" class="form-control" v-model="form.email"></input>
                                        <label v-if="validation.email != ''" class="error">{{ validation.email }}</label>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.street != '', 'has-danger' : validation.street != '' }">
                                        <label class="bmd-label-floating">Rua</label>
                                        <input refs="street" type="text" class="form-control" v-model="form.street" />
                                        <label v-if="validation.street != ''" class="error">{{ validation.street }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.neighborhood != '', 'has-danger' : validation.neighborhood != '' }">
                                        <label class="bmd-label-floating">Bairro</label>
                                        <input refs="neighborhood" type="text" class="form-control" v-model="form.neighborhood" />
                                        <label v-if="validation.neighborhood != ''" id="neighborhood-error" class="error">{{ validation.neighborhood }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.city != '', 'has-danger' : validation.city != '' }">
                                        <label class="bmd-label-floating">Cidade</label>
                                        <input refs="city" type="text" class="form-control" v-model="form.city" />
                                        <label v-if="validation.city != ''" class="error">{{ validation.city }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.state != '', 'has-danger' : validation.state != '' }">
                                        <label class="bmd-label-floating">Estado</label>
                                        <input refs="state" type="text" class="form-control" v-model="form.state" />
                                        <label v-if="validation.state != ''" id="state-error" class="error">{{ validation.state }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.details != '', 'has-danger' : validation.details != '' }">
                                        <label class="bmd-label-floating">Detalhes</label>
                                        <textarea refs="details" type="text" class="form-control" v-model="form.details"></textarea>
                                        <label v-if="validation.details != ''" class="error">{{ validation.details }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled"
                                         v-bind:class="{'has-danger' : validation.value != '' }">
                                        <label class="bmd-label-floating">Valor de Interesse *</label>
                                        <money v-model="form.value" maxlength="13" class="form-control" v-bind="money" placeholder=""></money>
                                        <label v-if="validation.value != ''" class="error">{{ validation.value }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <form-buttons
                                    v-bind:to-back="{name: 'leads.agenda.index'}"
                                    text-back="Voltar"
                                    icon-back="keyboard_arrow_left" />
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Validation from '@/services/validations.service';

    export default {
        data() {
            return {
                form: {
                    city: '',
                    details: '',
                    email: '',
                    lead_status_id: '',
                    name: '',
                    neighborhood: '',
                    phone: '',
                    state: '',
                    street: '',
                    value: '',
                },
                leads_status: [],
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                validation: {
                    city: '',
                    details: '',
                    email: '',
                    lead_status_id: '',
                    name: '',
                    neighborhood: '',
                    phone: '',
                    state: '',
                    street: '',
                    value: '',
                }
            };
        },
        methods: {
            clearForm() {
                var self = this;
                Object.keys(this.form).forEach(function (key, index) {
                    self.form[key] = '';
                });
            },
            async getDataStatus() {
                var self = this;

                self.$root.$emit('onLoading');

                const response = self.$store.dispatch('lead_status/all');

                response.then(function (x) {
                    self.$root.$emit('onLoading');
                    self.leads_status = x;
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            },
            onSubmit(_ev) {
                var self = this;
                var valid = true;
                self.validation.email = '';
                self.validation.name = '';
                self.validation.lead_status_id = '';
                self.validation.phone = '';
                self.validation.phone = '';

                if (self.form.email.length >= 1 && !Validation.mail(self.form.email)) {
                    self.validation.email = "E-mail inválido!";
                    valid = false;
                }

                if (self.form.name == '') {
                    self.validation.name = 'Campo obrigatório!';
                    valid = false;
                }

                if (self.form.lead_status_id == '') {
                    self.validation.leads_status_id = 'Campo obrigatório!';
                    valid = false;
                }

                if (self.form.phone == '') {
                    self.validation.phone = 'Campo obrigatório!';
                    valid = false;
                }


                if (self.form.value == '') {
                    self.validation.value = 'Campo obrigatório!';
                    valid = false;
                }

                if (valid) {
                    self.$root.$emit('onLoading');

                    const response = self.$store.dispatch('lead/add', this.form);

                    response.then(function () {
                        self.$root.$emit('onLoading');
                        self.$notify.success("Lead cadastrado com sucesso!");
                        self.clearForm();
                    });

                    response.catch(function (err) {
                        self.$root.$emit('onLoading');

                        if (err.status === 422) {
                            if (err.data.message !== undefined) {
                                self.$notify.error(err.data.message);
                            }

                            if (err.data.hasOwnProperty('errors') && err.data.errors.name !== undefined) {
                                self.validation.name = err.data.errors.name[0];
                            }

                        }
                    });
                }

                _ev.preventDefault();
            }
        },
        mounted: function() {
            var self = this;
            self.getDataStatus();
        }
    };
</script>